import { render } from "./EmployeePerformanceSelf.vue?vue&type=template&id=81234ae4&scoped=true"
import script from "./EmployeePerformanceSelf.vue?vue&type=script&lang=js"
export * from "./EmployeePerformanceSelf.vue?vue&type=script&lang=js"

import "./EmployeePerformanceSelf.vue?vue&type=style&index=0&id=81234ae4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81234ae4"]])

export default __exports__